import { PropTypes } from "react";
import L from "leaflet";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { MapLayer } from "react-leaflet";
import "./style.css";

import MapMarker from "./../MapMarker";

class MapCluster extends MapLayer {
    createLeafletElement() {
        const markerClusterGroup = L.markerClusterGroup({
            showCoverageOnHover: false,
            maxClusterRadius: 60,
            iconCreateFunction: (cluster) => {
                const count = cluster.getChildCount();
                let size;
                let iconUrl;

                if (count < 10) {
                    size = 40;
                    iconUrl = "/cluster/m1.png";
                } else if (count < 100) {
                    size = 54;
                    iconUrl = "/cluster/m2.png";
                } else if (count < 1000) {
                    size = 72;
                    iconUrl = "/cluster/m3.png";
                } else {
                    size = 88;
                    iconUrl = "/cluster/m4.png";
                }

                return L.divIcon({
                    html: `<div style="background-image: url(${iconUrl}); width: ${size}px; height: ${size}px; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold;">
                        ${count}
                    </div>`,
                    className: "marker-cluster",
                    iconSize: L.point(size, size),
                });
            },
        });

        this.addMarkers(markerClusterGroup);
        return markerClusterGroup;
    }

    addMarkers(markerClusterGroup) {
        const { locations, location } = this.props;

        if (!locations) {
            console.warn("No locations provided to MapCluster");
            return;
        }

        locations.forEach((marker) => {
            const { coordinates, description, id } = marker;

            if (!coordinates || !coordinates.lat || !coordinates.lng) {
                console.warn("Invalid coordinates for marker:", marker);
                return;
            }

            const isBigMarker = location && location.lat === coordinates.lat;
            const markerPosition = [coordinates.lat, coordinates.lng];

            const leafletMarker = L.marker(markerPosition, {
                icon: MapMarker.createIcon(isBigMarker),
            });

            leafletMarker.bindPopup(`
                <div>
                    <h4>${description}</h4>
                    <a href="/kirke/${id}" target="_blank">Les mer om ${description}</a>
                </div>
            `);

            markerClusterGroup.addLayer(leafletMarker);
        });
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentDidUpdate({ locations: prevLocations }) {
        if (this.props.locations !== prevLocations) {
            const markerCluster = this.leafletElement;
            markerCluster.clearLayers();
            this.addMarkers(markerCluster);
        }
    }
}

MapCluster.propTypes = {
    locations: PropTypes.array,
    location: PropTypes.object,
};

export default MapCluster;



// WEBPACK FOOTER //
// ./src/components/MapCluster/index.js